module.exports = __webpack_public_path__ + "img/india-post.b962e185.jpg";